<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>

        <div
          class="col-lg-6 col-md-6 col-sm-6 col-6 align-items-center text-right"
        >
          <div class="box-buttons">
            <base-button
              type="primary"
              class="min-button ml-2 no-mb "
              @click="saveReservation()"
              :disabled="buttonDisabled"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid  mb-5">
      <div class="row mb-5">
        <div class="col-12">
          <tabs
            tabNavClasses="tab-min justify-content-center"
            :value="tabActive"
            @changeTabActive="changeTabActive"
          >
            <tab-pane id="reservation" title="Reservation" ref="reservation">
              <div class="forms pt-3 border-top">
                <div class="row">
                  <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="row">
                      <div class="col-xl-12">
                        <ProductCard
                          :product="product"
                          :source="'VENTRATA'"
                          :productId="productId"
                        />
                      </div>

                      <div class="col-xl-12">
                        <div class="card">
                          <h2 class="subtitle mb-4">Reservation Info</h2>
                          <div class="row">
                            <div
                              class="col-xl-7 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="row">
                                <div
                                  class="col-xl-12 mb-3"
                                  v-if="product.options.length > 1"
                                >
                                  <label
                                    for="passengers"
                                    class="title-label ml-0"
                                    ><span class="markrequired">*</span>
                                    Options</label
                                  >

                                  <div class="internal-box box-options">
                                    <div
                                      class="row item-options"
                                      v-for="(item, index) in product.options"
                                      :value="item.id"
                                      :key="`${index}`"
                                    >
                                      <input
                                        type="radio"
                                        :id="index"
                                        name="options"
                                        class="radio-input"
                                        v-model="booking.optionId"
                                        :value="item.id"
                                      />
                                      <div
                                        class="row-options"
                                        :class="{
                                          active: booking.optionId === item.id
                                        }"
                                        @click="selectOption(item)"
                                      >
                                        <span class="title">{{
                                          item.internalName
                                        }}</span>
                                        <span class="description">{{
                                          item.shortDescription
                                        }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="col-xl-12 mb-4">
                                  <div
                                    class="internal-box box-passengers"
                                    :class="{
                                      'is-invalid': $v.booking.units.$error
                                    }"
                                  >
                                    <label
                                      for="passengers"
                                      class="title-label ml-0"
                                      ><span class="markrequired">*</span>
                                      PAX</label
                                    >

                                    <div
                                      v-if="option"
                                      class="row item-passengers"
                                      v-for="(unit, index) in optionUnits"
                                      :value="unit.title"
                                      :key="index"
                                    >
                                      <div
                                        class="col-lg-5 col-md-5 col-sm-5 col-4 align-self-center pr-0"
                                      >
                                        <span class="title"
                                          >{{ unit.internalName }}
                                        </span>
                                        <span class="age">{{
                                          unit.subtitle
                                        }}</span>
                                      </div>
                                      <div
                                        class="col-lg-7 col-md-7 col-sm-7 col-8 align-self-center"
                                      >
                                        <ul class="selpass">
                                          <li v-if="unit.pricingFrom">
                                            <span
                                              class="price"
                                              :class="
                                                unit.pricing.retail !==
                                                unit.pricing.original
                                                  ? 'text-success'
                                                  : ''
                                              "
                                            >
                                              {{
                                                getCurrenSymbolByCurrency(
                                                  product.defaultCurrency
                                                )
                                              }}
                                              {{
                                                getPriceByCurrencyPrecision(
                                                  unit.pricing.retail,
                                                  unit.pricing.currencyPrecision
                                                )
                                              }}
                                              {{ product.defaultCurrency }}
                                            </span>
                                            <span
                                              class="price with-discount"
                                              v-if="
                                                unit.pricing.retail !==
                                                  unit.pricing.original
                                              "
                                            >
                                              {{
                                                getCurrenSymbolByCurrency(
                                                  product.defaultCurrency
                                                )
                                              }}
                                              {{
                                                getPriceByCurrencyPrecision(
                                                  unit.pricing.original,
                                                  unit.pricing.currencyPrecision
                                                )
                                              }}
                                              {{
                                                product.defaultCurrency
                                              }}</span
                                            >
                                          </li>
                                          <li></li>
                                          <li>
                                            <base-button
                                              class="d-sm-block d-none"
                                              outline
                                              type="secondary"
                                              @click="
                                                subtractPAX(
                                                  unit,
                                                  units[index].quantity
                                                )
                                              "
                                              >-</base-button
                                            >
                                          </li>
                                          <li>
                                            <BaseNumberInput
                                              v-model.number="
                                                units[index].quantity
                                              "
                                              mode="integer"
                                              :id="index"
                                              name="passengersCount"
                                              class="w-70px mb-0 no-spin-buttons"
                                            />
                                          </li>
                                          <li>
                                            <base-button
                                              class="d-sm-block d-none"
                                              outline
                                              type="primary"
                                              @click="
                                                addPAX(
                                                  unit,
                                                  units[index].quantity
                                                )
                                              "
                                              >+</base-button
                                            >
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                  <small
                                    class="invalid-feedback"
                                    v-if="$v.booking.units.$error"
                                  >
                                    Select at least one participant
                                  </small>
                                </div>

                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                                  v-if="pickupPoints.length > 0"
                                >
                                  <label
                                    for="passengers"
                                    class="title-label ml-0"
                                    :class="{
                                      'is-invalid':
                                        $v.booking.pickupPointId.$error
                                    }"
                                    ><span class="markrequired">*</span>
                                    Pickup</label
                                  >

                                  <div
                                    class="internal-box box-options "
                                    :class="{
                                      'is-invalid':
                                        $v.booking.pickupPointId.$error
                                    }"
                                  >
                                    <span>{{ pickupMessage }}</span>
                                    <div
                                      class="row item-options"
                                      v-for="(item, index) in pickupPoints"
                                      :key="`${index}`"
                                    >
                                      <div
                                        class="row-options d-flex align-items-center"
                                        :class="{
                                          active:
                                            booking.pickupPointId === item.id
                                        }"
                                        @click="selectPickup(item)"
                                      >
                                        <i
                                          class="flaticon-pin d-inline-flex mr-2"
                                        ></i>
                                        <div class="d-inline-block">
                                          <span class="title">{{
                                            item.address
                                          }}</span>
                                          <span class="description">{{
                                            item.name
                                          }}</span>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="col-12 p-0 mt-4 no-invalid">
                                      <label
                                        for="passengers"
                                        class="title-label"
                                      >
                                        Pickup Notes</label
                                      >
                                      <el-input
                                        v-model="booking.pickupNotes"
                                        placeholder="Pickup Notes"
                                        id="Pickup Notes"
                                        name="Pickup Notes"
                                        maxlength="200"
                                        type="textarea"
                                        :autosize="{ minRows: 1, maxRows: 10 }"
                                        show-word-limit
                                      >
                                      </el-input>
                                    </div>
                                  </div>
                                  <small
                                    class="invalid-feedback"
                                    v-if="$v.booking.pickupPointId.$error"
                                  >
                                    Select a Pickup
                                  </small>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-5 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <div class="row">
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-4"
                                >
                                  <div
                                    class="internal-box no-plr"
                                    :class="{
                                      'is-invalid': $v.booking.travelDate.$error
                                    }"
                                  >
                                    <label for="time" class="title-label"
                                      ><span class="markrequired">*</span>
                                      Date
                                    </label>
                                    <base-input
                                      label=""
                                      markrequired
                                      inputClasses="calendar-box"
                                    >
                                      <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        @on-change="selectTravelDateInCalendar"
                                        @on-month-change="debouncedSelectMonth"
                                        :config="
                                          getFlatPickerSettings(
                                            booking.travelDate
                                          )
                                        "
                                        class="input-custom disabled d-none"
                                        v-model="booking.travelDate"
                                        id="date"
                                        name="date"
                                        placeholder="Date"
                                        ref="datepicker"
                                      ></flat-picker>
                                    </base-input>
                                  </div>
                                  <small
                                    class="invalid-feedback"
                                    v-if="$v.booking.travelDate.$error"
                                  >
                                    Select a Date
                                  </small>
                                </div>
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3"
                                >
                                  <label for="time" class="title-label"
                                    ><span class="markrequired">*</span>Schedule
                                  </label>

                                  <div
                                    class="internal-box box-times "
                                    :class="{
                                      'is-invalid':
                                        $v.booking.availabilityId.$error,
                                      max: hasMoreThanFiveDates(
                                        availability.options
                                      )
                                    }"
                                  >
                                    <template
                                      v-if="availableTimeRequest === 'PENDING'"
                                    >
                                      <div class="text-center p-4">
                                        <h4 class="mb-0">
                                          <strong
                                            >Looking for available
                                            times...</strong
                                          >
                                        </h4>
                                        <div id="loaderInner" class="my-3">
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                          <span></span>
                                        </div>
                                      </div>
                                    </template>
                                    <template v-else>
                                      <base-alert
                                        type="info"
                                        class="info-min mt-1 mb-0"
                                        v-if="
                                          allIntervalsEmpty(
                                            availability.options
                                          )
                                        "
                                      >
                                        <i class="flaticon-warning mr-1"></i>
                                        Schedules not available for the selected
                                        date
                                      </base-alert>

                                      <div
                                        class="item-times"
                                        v-for="item in availability.options"
                                      >
                                        <div
                                          v-if="
                                            item.dates.length &&
                                              item.intervalType !== 'ALL_DAY'
                                          "
                                        >
                                          <span class="group"
                                            >{{ item.intervalName }}
                                          </span>
                                          <div class="box-time box-flex">
                                            <div
                                              class="item-boxes"
                                              v-for="option in item.dates"
                                            >
                                              <div
                                                class="box-hour mb-2"
                                                :class="{
                                                  active:
                                                    booking.availabilityId ===
                                                    option.id
                                                }"
                                                @click="
                                                  selectAvailabilityId(option)
                                                "
                                              >
                                                <span class="hour">{{
                                                  getOptionTime(option.id)
                                                }}</span>
                                                <span
                                                  class="quantity"
                                                  :class="
                                                    option.status === 'SOLD_OUT'
                                                      ? 'text-danger'
                                                      : ''
                                                  "
                                                  >{{ getCapacity(option) }}
                                                </span>
                                                <span
                                                  class="price"
                                                  v-if="
                                                    option.pricing.retail > 0 &&
                                                      option.status !==
                                                        'SOLD_OUT'
                                                  "
                                                >
                                                  {{
                                                    getCurrenSymbolByCurrency(
                                                      option.pricing.currency
                                                    )
                                                  }}
                                                  {{
                                                    getFormatPrice(
                                                      option.pricing
                                                    )
                                                  }}
                                                  {{ option.pricing.currency }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div v-else>
                                          <div class="box-time box-flex">
                                            <div
                                              class="item-boxes"
                                              v-for="option in item.dates"
                                            >
                                              <div class="box-hour mb-0">
                                                <span class="hour"
                                                  >All Day</span
                                                >
                                                <span class="quantity"
                                                  >{{ getCapacity(option) }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </template>
                                  </div>
                                  <small
                                    class="invalid-feedback"
                                    v-if="$v.booking.availabilityId.$error"
                                  >
                                    Select a Schedule
                                  </small>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Customer / Contact Info -->
                      <div class="col-xl-12">
                        <div class="card">
                          <h2 class="subtitle mb-4">Customer / PAX</h2>
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                            >
                              <WSelect
                                label="Customer"
                                v-bind:class="{
                                  'is-invalid': $v.reservation.customer.$error
                                }"
                                filterable
                                remote
                                :remote-method="getCustomer"
                                :loading="loading"
                                placeholder="Enter Name Customer"
                                v-model="$v.reservation.customer.$model"
                                id="customer"
                                name="customer"
                                @input="selectCustomer"
                                no-data-text="Search by Customer"
                                clearable
                                markrequired
                              >
                                <el-option
                                  v-for="(customer, index) in customers"
                                  :value="customer._id"
                                  :label="getCustomerName(customer)"
                                  :key="index"
                                >
                                  <div class="row">
                                    <div class="col-7">
                                      <span
                                        class="role-table"
                                        v-if="isCompany(customer.type)"
                                        >{{ customer.company_name }}</span
                                      >
                                      <span
                                        >{{ customer.first_name }}
                                        {{ customer.last_name }}</span
                                      >
                                    </div>
                                    <div class="col-5 text-right hide-data">
                                      <span class="coin-right">{{
                                        formatClientType(customer.type)
                                      }}</span>
                                    </div>
                                  </div>
                                </el-option>
                              </WSelect>
                              <small
                                class="invalid-feedback"
                                v-if="$v.reservation.customer.$error"
                                >Enter a Customer</small
                              >

                              <div v-if="copyData" class="text-right">
                                <base-button
                                  class="linkfill"
                                  @click="copyDataCustomer"
                                  >+ Fill Customer Data</base-button
                                >
                              </div>
                            </div>
                            <AddCustomer
                              :show="modalCustomer"
                              @closeNewCustomerModal="closeNewCustomerModal"
                              @customer="addCustomerInOptions"
                            />

                            <div
                              class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3"
                            >
                              <base-button
                                @click="modalCustomer = true"
                                class="min-button"
                                type="outline-neutral"
                              >
                                <i
                                  class="flaticon-plus mr-1 d-sm-inline-block d-none"
                                ></i>
                                <span class=" d-sm-inline-block d-none">
                                  Add New</span
                                >
                                <span class="d-sm-none d-inline-block">
                                  Add</span
                                >
                              </base-button>
                            </div>

                            <div class="col-xl-2 d-xl-block d-lg-none"></div>

                            <div
                              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
                            >
                              <base-input
                                v-model.trim="
                                  $v.booking.contact.firstName.$model
                                "
                                label="PAX First Name"
                                placeholder="PAX First Name"
                                id="first_name_Contact"
                                name="first_name_Contact"
                                format="capitalize"
                                markrequired
                                @input="handlePassangerChange"
                                :error="
                                  $v.booking.contact.firstName.$error ||
                                  !$v.booking.contact.firstName.minLength ||
                                  !$v.booking.contact.firstName.ValName
                                    ? `Minimum 2 letters`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12"
                            >
                              <base-input
                                v-model.trim="
                                  $v.booking.contact.lastName.$model
                                "
                                label="PAX Last Name"
                                placeholder="PAX Last Name"
                                indexTab="17"
                                id="last_name_Contact"
                                format="capitalize"
                                name="last_name_Contact"
                                markrequired
                                @input="handlePassangerChange"
                                :error="
                                  $v.booking.contact.lastName.$error ||
                                  !$v.booking.contact.lastName.minLength ||
                                  !$v.booking.contact.lastName.ValName
                                    ? `Minimum 2 letters`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 form-group"
                            >
                              <label for="title" class="title-label"
                                >Gender</label
                              >

                              <b-form-group
                                v-slot="{ ariaDescribedby }"
                                class="mb-0"
                              >
                                <b-form-radio-group
                                  v-model="booking.contact.gender"
                                  @input="handlePassangerChange"
                                  :aria-describedby="ariaDescribedby"
                                  id="radio-gender"
                                  name="radio-gender"
                                  buttons
                                  button-variant="outline-neutral"
                                  size="md"
                                >
                                  <b-form-radio value="male" class="pc-4"
                                    >Mr.</b-form-radio
                                  >
                                  <b-form-radio value="female" class="pc-4"
                                    >Mrs.</b-form-radio
                                  >
                                  <b-form-radio value="other" class="pc-4"
                                    >Mx.</b-form-radio
                                  >
                                </b-form-radio-group>
                              </b-form-group>
                            </div>

                            <div
                              class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model.trim="$v.booking.contact.email.$model"
                                label="PAX Email"
                                placeholder="PAX Email"
                                id="Contact_email"
                                name="Contact_email"
                                format="lowercase"
                                @input="handlePassangerChange"
                                :error="
                                  $v.booking.contact.email.$error ||
                                  !$v.booking.contact.email.minLength ||
                                  !$v.booking.contact.email.email
                                    ? `Enter a valid email`
                                    : ''
                                "
                                markrequired
                              />
                            </div>
                            <div
                              class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone mb-3"
                              v-bind:class="{
                                'is-invalid': $v.booking.contact.phone.$error
                              }"
                            >
                              <label class="title-label"
                                ><span class="markrequired">*</span>Contact
                                Number</label
                              >
                              <vue-tel-input
                                v-model="contactNumber"
                                key="NumberPhone"
                                inputId="NumberPhone"
                                name="NumberPhone"
                                required
                                mode="international"
                                inputClasses="input no-err"
                                :dynamicPlaceholder="true"
                                :disabledFetchingCountry="true"
                                :validCharactersOnly="true"
                                :wrapperClasses="[
                                  $v.booking.contact.phone.$error
                                    ? 'is-invalid'
                                    : '',
                                  'mb-0'
                                ]"
                                @input="phoneInput"
                              ></vue-tel-input>
                            </div>
                            <div
                              class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <WSelect
                                v-model="$v.booking.contact.country.$model"
                                @input="handlePassangerChange"
                                label="Country"
                                placeholder="Enter a Country"
                                id="passenger_country"
                                name="passenger_country"
                                remote
                                filterable
                                reserve-keyword
                                :remote-method="remoteMethod"
                                :loading="loading"
                                clearable
                                :error="
                                  $v.booking.contact.country.$error
                                    ? `Select a Country`
                                    : ''
                                "
                              >
                                <el-option
                                  v-for="country in options"
                                  :value="country.currency_code"
                                  :label="country.name"
                                  :key="country.name"
                                ></el-option>
                              </WSelect>
                            </div>

                            <div class="col-xl-12 mb-4">
                              <label class="title-label">Notes</label>
                              <el-input
                                v-model="booking.contact.notes"
                                placeholder="Notes"
                                id="Notes"
                                name="Notes"
                                maxlength="200"
                                type="textarea"
                                :autosize="{ minRows: 1, maxRows: 5 }"
                                show-word-limit
                              >
                              </el-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-4 col-lg-12 pl-xl-0">
                    <Charges
                      :serviceType="'experience'"
                      :defaultCurrency="product.defaultCurrency"
                      :pricing="pricing"
                      :commissions="reservation.commissions"
                    />
                    <div class="row">
                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="card pb-3">
                          <h2 class="subtitle mb-3">Payment Details</h2>

                          <div class="row">
                            <div
                              class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <WSelect
                                placeholder="Payment Type"
                                v-model="reservation.payment_type"
                                id="paymentType"
                                name="paymentType"
                                @change="changePaymentType"
                                label="Payment Type"
                              >
                                <el-option
                                  v-for="option in paymentMethods"
                                  :value="option.value"
                                  :label="option.label"
                                  :key="option.label"
                                ></el-option>
                              </WSelect>
                            </div>

                            <div
                              class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                            >
                              <base-input
                                v-model.trim="reservation.invoice_number"
                                type="text"
                                label="Invoice Number"
                                placeholder="Invoice Number"
                                id="invoice_number"
                                name="invoice_number"
                              />
                            </div>

                            <div
                              class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                            >
                              <base-input
                                type="text"
                                label="Payment Reference N°"
                                placeholder="Payment Reference N°"
                                v-model="reservation.payment_reference"
                                id="paymentreference"
                                name="paymentreference"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                        <div class="card pb-3">
                          <h2 class="subtitle mb-3">External References</h2>

                          <div class="row">
                            <div
                              class="col-xl-12 col-lg-6 col-md-12 col-sm-6 col-12"
                            >
                              <base-input
                                type="text"
                                label="Reservation Reference"
                                placeholder="Reservation Reference"
                                v-model="
                                  $v.reservation.booking_reference.$model
                                "
                                id="booking_reference"
                                name="booking_reference"
                                indexTab="28"
                                :error="
                                  $v.reservation.booking_reference.$error
                                    ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                    : ''
                                "
                              />
                            </div>

                            <div
                              class="col-xl-12 col-lg-6 col-md-12 col-sm-6 col-12"
                            >
                              <base-input
                                placeholder="Zoho Deal Number"
                                v-model.trim="$v.reservation.deal_number.$model"
                                id="deal_number"
                                name="deal_number"
                                label="Zoho Deal Number"
                                type="text"
                                :error="
                                  dealNumberValidationMessage(
                                    $v.reservation.deal_number
                                  )
                                "
                              ></base-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>

            <tab-pane id="details" title="Experience Details" ref="details">
              <div>
                <div class="details-products">
                  <div class="px-sm-1 px-0 border-top pt-3">
                    <div class="products">
                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-7 col-md-12 col-sm-12 col-12 mb-4"
                        >
                          <div class="product-details">
                            <div class="card">
                              <h2 class="product-title">{{ product.title }}</h2>
                              <div class="mb-4">
                                <div
                                  v-if="product.description"
                                  v-html="product.description"
                                  class="product-description"
                                ></div>

                                <p
                                  v-else-if="product.shortDescription"
                                  v-html="product.shortDescription"
                                ></p>

                                <p v-else>
                                  An experience that will make you enjoy
                                  incredible moments and create unforgettable
                                  memories, transforming the way you see the
                                  world. Live something unique!
                                </p>
                              </div>

                              <div
                                class="mb-4"
                                v-if="product.highlights.length"
                              >
                                <h2>Highlights</h2>
                                <ul class="highlights">
                                  <li
                                    v-for="(item, index) in product.highlights"
                                    :value="item"
                                    :label="item"
                                    :key="index"
                                  >
                                    {{ item }}
                                  </li>
                                </ul>
                              </div>

                              <div class="row ">
                                <div
                                  class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                                  v-if="product.inclusions.length"
                                >
                                  <div class="mb-4">
                                    <h2>What's Included</h2>
                                    <div class="row">
                                      <div
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 "
                                        v-for="(item,
                                        index) in product.inclusions"
                                        :value="item"
                                        :label="item"
                                        :key="index"
                                      >
                                        <li class="inclusions">{{ item }}</li>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="col-xl-6 col-lg-12 col-md-6 col-sm-6 col-12 box-flex"
                                  v-if="product.exclusions.length"
                                >
                                  <div class="mb-4">
                                    <h2>What's not Included</h2>
                                    <div class="row">
                                      <div
                                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                                        v-for="(item,
                                        index) in product.exclusions"
                                        :value="item"
                                        :label="item"
                                        :key="index"
                                      >
                                        <li class="exclusions">{{ item }}</li>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div v-if="itinerary.length > 0" class="mb-4">
                                <h2>Itinerary</h2>

                                <div class="collapse-itinerary">
                                  <collapse>
                                    <collapse-item
                                      type="show"
                                      :name="index"
                                      v-for="(point, index) in itinerary"
                                      :key="index"
                                      :title="point.name"
                                      class="itinerary"
                                      :class="{ start: point.type === 'START' }"
                                    >
                                      <div class="description-itinerary">
                                        <p
                                          class="mb-3"
                                          v-html="point.description"
                                        ></p>

                                        <div class="item">
                                          <i class="flaticon-pin"></i>
                                          <span
                                            ><strong>Address: </strong
                                            >{{ point.address }}</span
                                          >
                                        </div>

                                        <div class="item">
                                          <span>
                                            <i class="flaticon-route"></i>
                                            <span
                                              ><strong>Time: </strong
                                              >{{ point.travelTime }}</span
                                            >
                                          </span>
                                        </div>

                                        <div class="item">
                                          <i class="flaticon-time"></i>
                                          <span
                                            ><strong>Duration: </strong
                                            >{{ point.duration }}</span
                                          >
                                        </div>
                                      </div>
                                    </collapse-item>
                                  </collapse>
                                </div>
                              </div>

                              <div
                                v-if="product.cancellationPolicy"
                                class="mt-4"
                              >
                                <h2>Cancellation Policy</h2>
                                <p v-html="product.cancellationPolicy"></p>
                              </div>

                              <div v-if="product.faqs.length" class="mb-4">
                                <h2>FAQs</h2>

                                <ul class="list-faq">
                                  <li
                                    v-for="(point, index) in product.faqs"
                                    :key="index"
                                    class="mb-2"
                                  >
                                    <div class="d-flex align-items-center">
                                      <i
                                        :class="{
                                          'flaticon-question': point.answer,
                                          'flaticon-check-3': !point.answer
                                        }"
                                        class="mr-2 d-inline-flex"
                                      ></i>
                                      <p
                                        :class="{
                                          'font-weight-bold': point.answer
                                        }"
                                        v-html="point.question"
                                      ></p>
                                    </div>

                                    <p class="ml-4" v-html="point.answer"></p>
                                  </li>
                                </ul>
                              </div>

                              <div v-if="product.bookingTerms">
                                <div v-if="product.bookingTerms.length > 2000">
                                  <collapse>
                                    <collapse-item
                                      type="show"
                                      name="terms"
                                      key="0"
                                      title="Terms"
                                      class="terms"
                                    >
                                      <p v-html="product.bookingTerms"></p>
                                    </collapse-item>
                                  </collapse>
                                </div>

                                <div v-else>
                                  <h2>Terms</h2>

                                  <div
                                    class="terms"
                                    v-html="product.bookingTerms"
                                  ></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div
                          class="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-12 mb-3 products"
                        >
                          <div
                            class="card content-price pt-3 pb-4"
                            v-if="pricingFrom"
                          >
                            <span class="amount-price"
                              >From
                              <strong class="price">
                                {{
                                  getCurrenSymbolByCurrency(
                                    product.defaultCurrency
                                  )
                                }}
                                {{
                                  getPriceByCurrencyPrecision(
                                    pricingFrom.retail,
                                    pricingFrom.currencyPrecision
                                  )
                                }}
                                {{ product.defaultCurrency }}
                              </strong>
                            </span>
                            <span class="info-price">Price varies by Pax</span>
                          </div>
                          <div class="row">
                            <div
                              class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12 mb-lg-0 mb-sm-4"
                            >
                              <div
                                class="image-slide"
                                v-if="gallery.length > 0"
                              >
                                <b-carousel
                                  id="productsCarousel"
                                  ref="productsCarousel"
                                  v-model="imgCarousel"
                                  :interval="7000"
                                  controls
                                  indicators
                                  @sliding-start="onSlideStart"
                                  @sliding-end="onSlideEnd"
                                  class="carousel-experiences-min"
                                >
                                  <template #prev>
                                    <button @click="prev">Prev</button>
                                  </template>

                                  <b-carousel-slide
                                    v-for="(image, i) in gallery"
                                    :key="i"
                                  >
                                    <template #img>
                                      <LazyImage
                                        :src="image.url"
                                        :alt="`${image.caption}`"
                                        imgClasses="img-carousel-min curp"
                                        @click="openBox(i)"
                                      />
                                    </template>
                                    <span
                                      v-if="image.caption"
                                      class="title-carousel"
                                      >{{ image.title }}</span
                                    >
                                  </b-carousel-slide>
                                </b-carousel>

                                <LightBox
                                  v-if="showLightbox"
                                  :media="imagesExperiences"
                                  :showLightBox="showLightbox"
                                  :startAt="currentImageIndex"
                                />
                              </div>

                              <div class="" v-else>
                                <LazyImage
                                  :src="noImage"
                                  alt="noimage"
                                  imgClasses="img-carousel-min curp"
                                />
                              </div>
                            </div>

                            <div
                              class="col-xl-12 col-lg-12 col-md-6 col-sm-12 col-12 mt-4"
                            >
                              <div class="card">
                                <div
                                  class="grid-container"
                                  v-if="product.destination"
                                >
                                  <div
                                    class="grid-item"
                                    v-if="product.categories.length > 0"
                                  >
                                    <strong class="b-color">Category:</strong>
                                  </div>
                                  <div
                                    class="grid-item"
                                    v-if="product.categories.length > 0"
                                  >
                                    {{ getCategories(product.categories) }}
                                  </div>
                                  <div class="grid-item">
                                    <strong class="b-color">Supplier:</strong>
                                  </div>
                                  <div class="grid-item">
                                    {{ product.destination.contact.name }}
                                  </div>

                                  <div class="grid-item">
                                    <strong class="b-color"
                                      >Destination:</strong
                                    >
                                  </div>
                                  <div class="grid-item">
                                    {{ product.location }}
                                  </div>
                                  <div
                                    class="grid-item"
                                    v-if="showDurationByOption(product.options)"
                                  >
                                    <strong class="b-color">Duration:</strong>
                                  </div>
                                  <div
                                    class="grid-item"
                                    v-if="showDurationByOption(product.options)"
                                  >
                                    {{ getDurationByOption(product.options) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab-pane>
          </tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import lodash from "lodash";
import LightBox from "vue-image-lightbox";
import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import AddCustomer from "../../../components/transfer/AddCustomer.vue";
import Charges from "../components/ChargesExperiences";
import { ReservationsAPI, VentrataAPI } from "../../../core/api";
import ProductCard from "../components/ProductCard";
import debounce from "lodash.debounce";

import {
  required,
  minLength,
  maxLength,
  alphaNum,
  email
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect
} from "element-ui";
import { PAYMENT_METHODS } from "../../../helpers/reservation.helpers";
import { calculateCommissionAmount } from "../../pricing";
import { goBack, setSigOut } from "../../../helpers/commons.helpers";
import { dealNumberValidationMessage } from "../services/validation.service";
import { formatClientType } from "../services/format.service";
import { alphabeticallySort } from "../services/client.service";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "NewReservationsVentrata",
  data() {
    return {
      booking: {
        productId: null,
        availabilityId: null,
        optionId: null,
        units: [],
        travelDate: moment().format("YYYY-MM-DD"),
        pickupPointId: null,
        pickupNotes: null,
        contact: {
          firstName: "",
          lastName: "",
          fullName: "",
          email: "",
          phone: "",
          gender: "",
          type: "ADULT",
          primary: true,
          flightNumber: "",
          country: "",
          notes: ""
        }
      },
      reservation: {
        payment_type: "card",
        customer: null,
        booking_reference: "",
        payment_reference: "",
        invoice_number: "",
        owner: "admin",
        agent: null,
        metadata: {},
        deal_number: "",
        passengers: [],
        responsible: {
          type: "Users",
          ref: ""
        },
        notificaition: {
          configTag: "rhomtrip_internal",
          configRef: null
        },
        commissions: {
          payment_processor: {
            amount: 0.0,
            percentage: 0.0
          },
          platform: {
            amount: 0.0,
            percentage: 0.0
          }
        },
        source: {
          origin: "RhomTrip Internal",
          type: "INTERNAL",
          provider: "VENTRATA",
          channel: "SYSTEM",
          medium: "APP"
        },
        providerId: null
      },
      reservationCopy: {},
      bookingCopy: {},
      buttonDisabled: false,
      tabActive: "Reservation",
      loading: false,
      imagesExperiences: [],
      showLightbox: false,
      currentImageIndex: 0,
      imgCarousel: 0,
      product: {
        title: "",
        code: "",
        country: "US",
        subtitle: "",
        description: "",
        shortDescription: "",
        pickupPoints: [],
        defaultCurrency: "",
        availableCurrencies: [""],
        inclusions: [],
        exclusions: [],
        highlights: [],
        redemptionInstructions: null,
        bookingTerms: null,
        cancellationPolicy: null,
        importantInformation: [],
        destination: null,
        faqs: [],
        coverImageUrl: "",
        bannerImageUrl: "",
        videoUrl: "",
        galleryImages: [],
        bannerImages: [],
        cancellationPolicy: null,
        meetingPoint:
          "Redeem this voucher at 2724 Taylor St, San Francisco, CA, 94133. You can call us at 415-440-8687 if you have any questions.",
        meetingPointCoordinates: [38.8951, -77.0364],
        options: [],
        location: "",
        categories: []
      },
      mode: "edit",
      pickupMessage: "",
      customers: [],
      copyData: false,
      modalCustomer: false,
      contactNumber: "",
      paymentMethods: PAYMENT_METHODS,
      gallery: [],
      options: [],
      productId: null,
      option: {
        units: []
      },
      currentMonth: moment().month(),
      travelDate: moment().format("YYYY-MM-DD"),
      localDateStart: null,
      localDateEnd: null,
      availabilities: [],
      availabilityType: "",
      availability: {
        options: []
      },
      schedules: [],
      datesAvailable: [],
      pricing: {
        currency: "",
        currencyPrecision: 0,
        includedTaxes: [],
        net: 0,
        original: 0,
        retail: 0
      },
      itinerary: [],
      pickupAvailable: false,
      pickupPoints: [],
      pickupRequired: false,
      noImage: require("rhomtrip_assets/src/img/no-image-available.png"),
      optionUnits: [],
      pricingFrom: null,
      isReservationSaved: false,
      commissionApplied: 0,
      providerId: null,
      availableTimeRequest: "INIT",
      debouncedSelectMonth: null,
      customer: null
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Reservations",
        to: "/reservations"
      },
      {
        text: "New Experience Reservation",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.debouncedSelectMonth = debounce(this.selectMonth, 500);
    this.productId = this.$route.query.productId;
    this.providerId = this.$route.query.providerId;
    this.booking.productId = this.productId;
    this.customers = this.customerOptions;
    this.localDateStart = this.getLocalDateStart(this.currentMonth);
    this.localDateEnd = this.getLocalDateEnd(this.currentMonth);
    this.reservation.responsible.ref = this.sesion.id;
    this.reservation.providerId = this.providerId;
    this.reservationCopy = lodash.cloneDeep(this.reservation);
    this.bookingCopy = lodash.cloneDeep(this.booking);
    await this.getProductDetails(this.productId, this.providerId);
    this.getAllProductImages(this.product);
  },
  methods: {
    dealNumberValidationMessage,
    formatClientType,
    async getProductDetails(productId, providerId) {
      try {
        this.setLoad(true);
        let { data } = await VentrataAPI.getProduct(
          productId,
          true,
          providerId
        );
        let product = data;
        this.product.title = product.title || product.internalName;
        this.product.code = product.code;
        this.product.country = product.country;
        this.product.subtitle = product.subtitle;
        this.product.description = product.description;
        this.product.shortDescription = product.shortDescription;
        this.product.defaultCurrency = product.defaultCurrency;
        this.product.availableCurrencies = product.availableCurrencies;
        this.product.inclusions = product.inclusions;
        this.product.exclusions = product.exclusions;
        this.product.highlights = product.highlights;
        this.product.redemptionInstructions = product.redemptionInstructions;
        this.product.bookingTerms = product.bookingTerms;
        this.product.cancellationPolicy = product.cancellationPolicy;

        this.product.videoUrl = product.videoUrl;
        this.product.galleryImages = product.galleryImages;
        this.product.bannerImages = product.bannerImages;
        this.product.faqs = product.faqs;
        this.product.coverImageUrl = product.coverImageUrl;
        this.product.bannerImageUrl = product.bannerImageUrl;

        this.product.destination = product.destination;
        this.product.location = product.location;
        this.product.categories = product.categories;

        this.product.options = product.options;
        this.product.availabilityType = product.availabilityType;
        this.product.providerId = providerId;
        this.availabilityType = this.product.availabilityType;
        this.commissionApplied = await this.getCommissionsByProductId(
          productId
        );
        this.option = this.getDefaultOption(this.product.options);
        this.optionUnits = this.getOptionsUnitsWithPricesBycurrency(
          this.product.defaultCurrency,
          this.option.units
        );
        this.pricingFrom = this.getPricingFromByUnits(
          this.option.units,
          this.product.defaultCurrency
        );
        this.booking.optionId = this.option ? this.option.id : null;
        this.itinerary = this.option.itinerary ? this.option.itinerary : [];
        this.units = this.option.units.map(unit => {
          return {
            id: unit.id,
            quantity: 0
          };
        });
        this.booking.units = this.units.filter(unit => unit.quantity > 0);
        await this.getAvailabilityAndSchedules();
        this.datesAvailable = this.getDatesAvailable(this.schedules);
        this.selectTravelDate(this.booking.travelDate);
        this.setLoad(false);
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    getCategories(categories = []) {
      return categories.map(category => category.name).join(", ");
    },
    getDefaultOption(options = []) {
      let [option] = options;
      return option;
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-check-3"
      });
    },
    onDayCreate(dObj, dStr, fp, dayElem) {
      const date = moment(dayElem.dateObj);
      const isDisabled = this.datesAvailable.some(disabledDate =>
        date.isSame(moment(disabledDate), "day")
      );
      if (!isDisabled) {
        dayElem.classList.add("special-disabled");
        dayElem.setAttribute("title", "Date not available");
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    openBox(index) {
      this.currentImageIndex = index;
      this.imagesExperiences = this.getNewPicturesFormat(this.gallery);
      this.showLightbox = false;
      this.$nextTick(() => {
        this.showLightbox = true;
      });
    },
    getNewPicturesFormat(images) {
      return images.map((image, index) => {
        return {
          thumb: image.url,
          src: image.url
        };
      });
    },
    async selectOption(option) {
      this.option = option;
      this.booking.optionId = option.id;
      this.optionUnits = this.getOptionsUnitsWithPricesBycurrency(
        this.product.defaultCurrency,
        this.option.units
      );
      this.itinerary = this.option.itinerary ? this.option.itinerary : [];
      this.units = this.option.units.map(unit => {
        return {
          id: unit.id,
          quantity: 0
        };
      });
      this.booking.units = this.units.filter(unit => unit.quantity > 0);
      await this.getAvailabilityAndSchedules();
      this.selectTravelDate(this.booking.travelDate);
    },
    selectPickup(pickUp) {
      this.booking.pickupPointId = pickUp.id;
    },
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().indexOf(input.trim().toLowerCase()) > -1 ||
              customer.company_name.toLowerCase().indexOf(input.toLowerCase()) >
                -1
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (this.booking.units.length === 0) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected the number of PAX`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
          this.customerId = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          this.copyData = true;
          this.populateCommission(
            this.customer,
            this.pricing,
            this.commissionApplied
          );
          if (["travel_access"].includes(this.customer.type)) {
            this.reservation.customer = this.customer.owner;
            this.reservation.agent = this.customer._id;
          } else {
            this.reservation.customer = this.customer._id;
            this.reservation.agent = null;
          }
        }
      }
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.customerId = customer._id;
        this.setCustomerOptions(this.customerOptions.contact([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status && this.customer) {
        this.reservation.customer = this.customer._id;
      }
    },
    phoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.booking.contact.phone = result.number.e164;
        let passenger = this.populatePassenger(
          lodash.cloneDeep(this.booking.contact)
        );
        this.reservation.passengers = [passenger];
      }
    },
    handlePassangerChange() {
      let passenger = this.populatePassenger(
        lodash.cloneDeep(this.booking.contact)
      );
      this.reservation.passengers = [passenger];
    },
    copyDataCustomer() {
      if (this.customer) {
        this.booking.contact.firstName = this.customer.first_name;
        this.booking.contact.lastName = this.customer.last_name;
        this.booking.contact.fullName = `${this.customer.first_name} ${this.customer.last_name}`;
        this.booking.contact.email = this.customer.email;
        this.booking.contact.phone = this.customer.phone;
        this.contactNumber = this.customer.phone;
        this.booking.contact.gender = this.customer.gender;
        let passenger = this.populatePassenger(
          lodash.cloneDeep(this.booking.contact)
        );
        this.reservation.passengers = [passenger];
      }
    },
    remoteMethod(value) {
      if (value !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(value.toLowerCase()) > -1;
          });
        }, 100);
      } else {
        this.options = [];
      }
    },
    changePaymentType(value) {
      if (value !== "credit") {
        this.creditAvailable = true;
      } else {
        if (this.customer) {
          this.checkIfCreditPaymentApplies(this.customer);
        }
      }
    },
    async createBookinng(booking, providerId) {
      try {
        let { data } = await VentrataAPI.createReservation(booking, providerId);
        if (data) {
          return data;
        } else {
        }
      } catch (error) {
        return null;
      }
    },
    async saveReservation(route = null) {
      if (!this.$v.reservation.$invalid && !this.$v.booking.$invalid) {
        this.setLoad(true);
        let booking = await this.createBookinng(
          this.populateBooking(lodash.cloneDeep(this.booking)),
          this.providerId
        );
        let reservation = this.populateReservation(booking);
        await this.createdReservation(
          { ...this.reservation, ...reservation },
          route
        );
        this.setLoad(false);
      } else {
        this.$v.reservation.$touch();
        this.$v.booking.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createdReservation(reservation, route = null) {
      try {
        this.buttonDisabled = true;
        let { data } = await ReservationsAPI.otaCreateRervation(
          reservation,
          this.sesion.token
        );
        this.buttonDisabled = false;
        this.isReservationSaved = true;
        if (data.code === 201) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Reservations has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(route ? route : "/reservations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.buttonDisabled = false;
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    changeTabActive(tabActive) {
      this.tabActive = tabActive;
    },
    async getAllProductImages(product) {
      let images = [];

      if (product.coverImageUrl) {
        images.push({
          url: product.coverImageUrl,
          title: "Cover",
          caption: ""
        });
      }

      if (product.galleryImages && product.galleryImages.length > 0) {
        images.push(...product.galleryImages);
      }

      if (product.bannerImageUrl) {
        images.push({
          url: product.bannerImageUrl,
          title: "Banner",
          caption: ""
        });
      }

      if (product.bannerImages && product.bannerImages.length > 0) {
        images.push(...product.bannerImages);
      }

      this.gallery = images;
    },
    getLocalDateStart(currentMonth) {
      return moment()
        .month(currentMonth)
        .startOf("month")
        .format("YYYY-MM-DD");
    },
    getLocalDateEnd(currentMonth) {
      return moment()
        .month(currentMonth)
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    async getAvailabilityAndSchedules() {
      this.availableTimeRequest = "PENDING";
      this.availabilities = await this.availabilityCheck(
        this.productId,
        this.booking.optionId,
        this.localDateStart,
        this.localDateEnd,
        this.booking.units,
        this.providerId
      );
      this.availableTimeRequest = "RESPONSE";
      this.schedules = this.getSchedules(
        this.localDateStart,
        this.localDateEnd,
        this.availabilities
      );
    },
    async subtractPAX(unit, quantity) {
      let indexUnit = this.units.findIndex(item => item.id === unit.id);
      if (indexUnit > -1) {
        this.units[indexUnit].quantity =
          quantity + -1 >= 0 ? this.units[indexUnit].quantity - 1 : 0;
        this.booking.units = this.units.filter(unit => unit.quantity > 0);
        await this.getAvailabilityAndSchedules();
      }
      this.selectTravelDate(this.booking.travelDate);
    },
    async addPAX(unit, quantity) {
      let indexUnit = this.units.findIndex(item => item.id === unit.id);
      if (indexUnit > -1) {
        this.units[indexUnit].quantity = this.units[indexUnit].quantity + 1;
        this.booking.units = this.units.filter(unit => unit.quantity > 0);
        await this.getAvailabilityAndSchedules();
      }
      this.selectTravelDate(this.booking.travelDate);
    },
    selectTravelDate(travelDate) {
      let schedule = this.schedules.find(schedule => {
        return schedule.date === travelDate;
      });
      if (schedule) {
        this.optionUnits = this.getOptionsUnitsWithPrices(
          schedule.availabilities,
          this.product.defaultCurrency,
          this.option.units
        );
        this.availability = this.getAvailabilityOptions(
          schedule.availabilities
        );
        if (
          this.availabilityType === "OPENING_HOURS" &&
          schedule.availabilities.length
        ) {
          let [availability] = schedule.availabilities;
          if (availability) {
            this.booking.availabilityId = availability.id;
            this.pickupAvailable = availability.pickupAvailable;
            this.pickupRequired = availability.pickupRequired;
            this.pickupPoints = availability.pickupPoints;
            this.pricing = availability.pricing;
            this.populateCommission(
              this.customer,
              this.pricing,
              this.commissionApplied
            );
          } else {
            this.booking.availabilityId = null;
          }
        } else {
          this.booking.availabilityId = null;
        }
      } else {
        this.booking.availabilityId = null;
      }
    },
    selectTravelDateInCalendar(dates, travelDate) {
      this.selectTravelDate(travelDate);
    },
    async selectMonth(dates, travelDate, instance) {
      this.currentMonth = instance.currentMonth;
      this.localDateStart = this.getLocalDateStart(this.currentMonth);
      this.localDateEnd = this.getLocalDateEnd(this.currentMonth);
      await this.getAvailabilityAndSchedules();
      this.datesAvailable = this.getDatesAvailable(this.schedules);
    },
    async availabilityCheck(
      productId,
      optionId,
      localDateStart,
      localDateEnd,
      units,
      providerId
    ) {
      try {
        let { data } = await VentrataAPI.availabilityCheck(
          {
            productId: productId,
            optionId: optionId,
            localDateStart: localDateStart,
            localDateEnd: localDateEnd,
            units: units
          },
          providerId
        );
        return data.length ? data : [];
      } catch (error) {
        return [];
      }
    },
    getPriceByUnit(pricingFrom = [], defaultCurrency) {
      let total = 0;
      let pricing = pricingFrom.find(
        element => element.currency === defaultCurrency
      );
      if (pricing) {
        total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      }
      return total.toFixed(2);
    },
    getSchedules(localDateStart, localDateEnd, availabilities = []) {
      let dates = Array.from(
        moment.range(localDateStart, localDateEnd).by("day")
      );
      return dates.map(date => {
        return {
          date: date.format("YYYY-MM-DD"),
          availabilities: this.getAvailabilitiesByDate(
            date.format("YYYY-MM-DD"),
            availabilities
          )
        };
      });
    },
    getAvailabilitiesByDate(date, availabilities = []) {
      return availabilities.filter(availability => {
        return availability.id.includes(date);
      });
    },
    getAvailabilityOptions(availabilities = []) {
      if (this.availabilityType === "OPENING_HOURS") {
        return {
          status: availabilities.length,
          type: this.availabilityType,
          options: [
            {
              intervalName: null,
              intervalType: "ALL_DAY",
              dates: availabilities
            }
          ]
        };
      } else {
        let morningHours = this.getAvailabilitiesByInterval(
          "6:00 AM",
          "11:59 AM",
          availabilities
        );
        let afternoonHours = this.getAvailabilitiesByInterval(
          "12:00 PM",
          "11:59 PM",
          availabilities
        );
        return {
          status: morningHours.length > 0 || afternoonHours.length > 0,
          type: this.availabilityType,
          options: [
            {
              intervalName: "Morning",
              intervalType: "MORNING",
              dates: morningHours
            },
            {
              intervalName: "Afternoon",
              intervalType: "AFTERNOON",
              dates: afternoonHours
            }
          ]
        };
      }
    },
    getAvailabilitiesByInterval(
      startInterval,
      endInterval,
      availabilities = []
    ) {
      return availabilities.filter(availability => {
        const time = moment.parseZone(availability.id);
        const timeToCheck = moment(time.format("h:mm A"), "h:mm A");
        return timeToCheck.isBetween(
          moment(startInterval, "h:mm A"),
          moment(endInterval, "h:mm A"),
          null,
          "[)"
        );
      });
    },
    getOptionTime(availabilityId) {
      return moment.parseZone(availabilityId).format("h:mm A");
    },
    selectAvailabilityId(availability) {
      if (availability.status !== "SOLD_OUT") {
        this.booking.availabilityId = availability.id;
        this.pickupAvailable = availability.pickupAvailable;
        this.pickupRequired = availability.pickupRequired;
        this.pickupPoints = availability.pickupPoints;
        this.pricing = availability.pricing;
        this.populateCommission(
          this.customer,
          this.pricing,
          this.commissionApplied
        );
      }
    },
    getFormatPrice(pricing) {
      let total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      return total.toFixed(2);
    },
    getCapacity(availability) {
      if (availability.status === "AVAILABLE" && availability.capacity > 0) {
        return `${availability.capacity} Remaining`;
      } else if (availability.status === "FREESALE") {
        return "Available";
      } else if (availability.status === "SOLD_OUT") {
        return "Sold Out";
      } else if (availability.status === "LIMITED") {
        return `${availability.capacity} Limited`;
      } else {
        return "";
      }
    },
    getDatesAvailable(schedules = []) {
      return schedules
        .filter(schedule => schedule.availabilities.length > 1)
        .map(schedule => {
          return schedule.date;
        });
    },
    getCurrenSymbolByCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      }
    },
    getCustomerName(customer) {
      if (
        ["travel_agency", "travel_access", "business"].includes(customer.type)
      ) {
        return `${customer.company_name} - ${customer.first_name} ${customer.last_name}`;
      } else {
        return `${customer.first_name} ${customer.last_name}`;
      }
    },
    isCompany(type) {
      return ["travel_agency", "travel_access"].includes(type);
    },
    getInterval(quantity) {
      const interval = [];
      for (let i = 0; i < quantity; i++) {
        interval.push(i + 1);
      }
      return interval;
    },
    getUnitItems(units = []) {
      return units
        .map(unit => {
          let interval = this.getInterval(unit.quantity);
          return interval.map(item => {
            return {
              unitId: unit.id,
              uuid: uuidv4()
            };
          });
        })
        .flat();
    },
    populatePassenger(contact) {
      return {
        _id: null,
        reference: uuidv4(),
        firstName: contact.firstName,
        lastName: contact.lastName,
        fullName: contact.fullName,
        email: contact.email,
        phone: contact.phone,
        gender: contact.gender,
        type: contact.type,
        primary: contact.primary,
        flightNumber: contact.flightNumber
      };
    },
    populateContact(contact) {
      return {
        fullName: contact.fullName,
        firstName: contact.firstName,
        lastName: contact.lastName,
        emailAddress: contact.email,
        phoneNumber: contact.phone,
        country: contact.country,
        notes: contact.notes
      };
    },
    populateBooking(booking) {
      return {
        uuid: uuidv4(),
        expirationMinutes: 720,
        productId: booking.productId,
        optionId: booking.optionId,
        availabilityId: booking.availabilityId,
        settlementMethod: "VOUCHER",
        pickupRequested: booking.pickupPointId ? true : false,
        pickupPointId: booking.pickupPointId,
        pickupNotes: booking.pickupNotes,
        unitItems: this.getUnitItems(booking.units),
        contact: this.populateContact(booking.contact)
      };
    },
    populateReservation(booking) {
      return booking
        ? {
            uuid: booking.uuid,
            id: booking.id,
            notes: booking.notes,
            option: booking.option,
            optionId: booking.optionId,
            pricing: booking.pricing,
            product: booking.product,
            productId: booking.productId,
            status: booking.status,
            unitItems: booking.unitItems,
            settlementMethod: booking.settlementMethod,
            supplierReference: booking.supplierReference,
            utcConfirmedAt: booking.utcConfirmedAt,
            utcCreatedAt: booking.utcCreatedAt,
            utcExpiresAt: booking.utcExpiresAt,
            utcNoshowedAt: booking.utcNoshowedAt,
            utcRebookedAt: booking.utcRebookedAt,
            utcRedeemedAt: booking.utcRedeemedAt,
            utcUpdatedAt: booking.utcUpdatedAt,
            contact: booking.contact,
            voucher: booking.voucher,
            availability: booking.availability,
            availabilityId: booking.availabilityId,
            deliveryMethods: booking.deliveryMethods,
            resellerReference: booking.resellerReference,
            meetingPoint: booking.meetingPoint,
            meetingPointCoordinates: booking.meetingPointCoordinates,
            meetingLocalDateTime: booking.meetingLocalDateTime,
            pickupPointId: booking.pickupPointId,
            pickupRequested: booking.pickupRequested,
            pickupPoint: booking.pickupPoint,
            pickupNotes: booking.pickupNotes,
            duration: booking.duration,
            cancellable: booking.cancellable,
            cancellation: booking.cancellation,
            confirmable: booking.confirmable
          }
        : {};
    },
    emptyAnswersCount() {
      return this.product.faqs.filter(
        faq => !faq.answer || faq.answer.trim() === ""
      ).length;
    },
    showFaqBoxes() {
      return this.emptyAnswersCount <= 1;
    },
    getPriceByCurrencyPrecision(price, currencyPrecision) {
      let total = price / Math.pow(10, currencyPrecision);
      return total.toFixed(2);
    },
    getOptionsUnitsWithPrices(availabilities, currency, units = []) {
      let [availability] = availabilities;
      return units.map(unit => {
        unit.pricing = availability
          ? availability.unitPricing.find(pricing => pricing.unitId === unit.id)
          : unit.pricingFrom.find(pricing => pricing.currency === currency);
        return unit;
      });
    },
    getOptionsUnitsWithPricesBycurrency(currency, units = []) {
      return units.map(unit => {
        unit.pricing = unit.pricingFrom.find(
          pricing => pricing.currency === currency
        );
        return unit;
      });
    },
    getPricingFromByUnits(units = [], defaultCurrency) {
      let [unit] = units;
      return unit ? this.getPricingFromByUnit(unit, defaultCurrency) : null;
    },
    getPricingFromByUnit(unit, defaultCurrency) {
      try {
        if (unit) {
          let pricing = unit.pricingFrom.find(
            pricing => pricing.currency === defaultCurrency
          );
          return pricing ? pricing : null;
        } else {
          return null;
        }
      } catch (error) {
        return null;
      }
    },
    areThereChanges() {
      return !(
        lodash.isEqual(this.reservation, this.reservationCopy) &&
        lodash.isEqual(this.booking, this.bookingCopy)
      );
    },
    async getCommissionsByProductId(productId) {
      try {
        let { data } = await ReservationsAPI.getCommissionByReference(
          productId,
          this.sesion.token
        );
        return data.status ? data.data.amount : 5;
      } catch (error) {
        return 5;
      }
    },
    getDurationByOption(options = []) {
      let [option] = options;
      return option ? option.duration : "";
    },
    showDurationByOption(options = []) {
      let [option] = options;
      if (option) {
        return option.duration ? true : false;
      }
      return false;
    },
    allIntervalsEmpty(intervals) {
      return intervals.every(interval => interval.dates.length === 0);
    },
    hasMoreThanFiveDates(intervals) {
      const totalDates = intervals.reduce((acc, interval) => {
        return acc + interval.dates.length;
      }, 0);
      return totalDates > 6;
    },
    getFlatPickerSettings(travelDate) {
      let toDay = moment().utc(true);
      let date = moment(travelDate).utc(false);
      return {
        inline: true,
        altFormat: "d-M-Y",
        altInput: true,
        minDate: date.isSameOrAfter(toDay) ? "today" : travelDate,
        maxDate: toDay.add(1, "year").format(),
        dateFormat: "Y-m-d",
        allowInput: false
      };
    },
    populateCommission(customer, pricing, commissionApplied) {
      //Calculate Commissions Platform
      this.reservation.commissions.platform.percentage = this.getCommissionByCustomer(
        customer,
        commissionApplied
      );

      this.reservation.commissions.platform.amount = calculateCommissionAmount(
        this.getGrossPriceByPricing(pricing),
        this.reservation.commissions.platform.percentage
      );
    },
    getCommissionByCustomer(customer, commissionApplied) {
      if (customer) {
        let commercialTerms = customer.commercialTerms || customer.type_charge;
        return ["travel_access", "travel_agency"].includes(customer.type) &&
          commercialTerms === "commission"
          ? commissionApplied
          : 0;
      }
      return 0;
    },
    getGrossPriceByPricing(pricing) {
      let total = pricing.retail / Math.pow(10, pricing.currencyPrecision);
      return parseFloat(total.toFixed(2));
    },
    goToPreviousPage() {
      goBack(this);
    },
    ...mapActions(["getSesion"]),
    ...mapMutations(["setSigOut", "setLoad", "setItemsBread"])
  },
  computed: {
    ...mapGetters(["sesion", "sigout", "customerOptions", "countries"])
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let isThereChanges = this.areThereChanges();
      if (isThereChanges && !this.isReservationSaved) {
        Swal.fire({
          title: "Important",
          html:
            "The Reservation has been modified.<br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",
          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.saveReservation(to.path, false);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  },
  validations: {
    booking: {
      units: {
        required,
        minLength: minLength(1)
      },
      travelDate: {
        required
      },
      availabilityId: {
        required
      },
      pickupPointId: {
        required: false
      },
      pickupNotes: {
        required: false
      },
      contact: {
        country: {
          required: false
        },
        email: {
          required,
          email,
          minLength: minLength(3)
        },
        firstName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        fullName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(90),
          ValName
        },
        lastName: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(45),
          ValName
        },
        phone: {
          required,
          minLength: minLength(10),
          maxLength: maxLength(17)
        }
      }
    },
    reservation: {
      customer: {
        required,
        alphaNum
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      deal_number: {
        maxLength: maxLength(10),
        customValidator: function(value) {
          if (value) {
            var regex = /^[A-Za-z]{3}-\d{5,6}$/;
            if (regex.test(value)) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        }
      }
    }
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    VueTelInput,
    WSelect: WSelect,
    AddCustomer,
    Charges: Charges,
    LightBox,
    ProductCard: ProductCard
  }
};
</script>
